export default function loadVideo(url) {
    return new Promise((resolve, reject) => {
        fetch(url)
            .then((r) => r.blob())
            .then((blob) => {
                const video = document.createElement('video');
                video.muted = true;
                video.playsInline = true;
                video.addEventListener('canplaythrough', () => {
                    resolve(video);
                });
                video.addEventListener('error', (err) => {
                    reject(err);
                });

                video.src = URL.createObjectURL(blob);
                video.load();
            })
            .catch((err) => {
                reject(err);
            });
    });
}
